module.exports = __webpack_public_path__ + "img/en.861e9106.png";